/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';
import { GlyphRight, IconHelp, TooltipButton } from '@americanexpress/dls-react';

// ours
import { StatsCardViewModel } from 'src/types/view-models/stats-card.view.model';
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

// styles and icons
import styles from './ProfileStatsCard.module.scss';
import LiteralsService from 'src/services/literals/LiteralsService';
import Tooltip from '../dlsMods/tooltip/Tooltip';
import Selectors from 'src/utils/selectors';

export default class ProfileStatsCard extends Component<StatsCardViewModel> {
    public override render(): ReactComponentElement<any> {
        const { className, colour, topText, middleText, bottomText, tooltipText, ctaText, onClick, ...props } =
            this.props;

        let allClassNames: string = styles.profileStatsCard;
        if (colour) allClassNames += ` ${colour}`; // TODO this should be included with the className prop
        if (className) allClassNames += ` ${className}`;

        return (
            <div className={allClassNames} {...props}>
                <div className={styles.statsCardTopRow}>
                    <div className={styles.topLeftColumn}>
                        <Typography component="h3" variant={TypographyVariants.BODY} className={styles.statsTopText}>
                            {topText}
                        </Typography>
                        <Typography component="p" variant={TypographyVariants.HEADING_M}>
                            {middleText}
                        </Typography>
                        <Typography variant={TypographyVariants.BODY}>{bottomText}</Typography>
                    </div>
                    <Tooltip
                        id="profileStatsTooltip"
                        triggerElement={
                            <TooltipButton
                                icon={<IconHelp title={LiteralsService.getLiteral('FinancialProfile.HelpIconTitle')} />}
                            />
                        }
                    >
                        <Typography variant={TypographyVariants.BODY}>{tooltipText}</Typography>
                    </Tooltip>
                </div>
                <div className={styles.statsDivider}>
                    <hr />
                </div>
                <button
                    className={styles.statsCardBottomRow}
                    data-cy={Selectors.PlanAhead.OVERVIEW_BUTTONS}
                    onClick={() => {
                        void onClick();
                    }}
                >
                    <Typography variant={TypographyVariants.SUBTEXT_BOLD} className={styles.actionText}>
                        {ctaText}
                    </Typography>
                    <GlyphRight className={styles.actionGlyph} />
                </button>
            </div>
        );
    }
}
